export const VERSION = "14.0.2";
export const RELEASE = "look-and-like@14.0.2";
